import type { RequestDocs } from '@/api/endpoints'
import type { HeaderRow } from '@/components/api-client/ApiClient'

export interface ApiClientDefaults {
  defaultUrl: string
  defaultHeaders: HeaderRow[]
  defaultBody: string
}

// パス内の `:key` をドキュメントの例値で置換し、クエリ例値を付加した実行可能な URL・
// ヘッダー初期値・ボディ初期値を組み立てる。ApiClient の defaultUrl/defaultHeaders/defaultBody に渡す。
export function buildApiClientDefaults(
  path: string,
  requestDocs: RequestDocs,
  baseUrl: string,
): ApiClientDefaults {
  let resolvedPath = path
  for (const p of requestDocs.path_params) {
    if (!p.key) continue
    resolvedPath = resolvedPath.replace(new RegExp(`:${p.key}\\b`, 'g'), p.example)
  }

  const params = new URLSearchParams()
  for (const q of requestDocs.query) {
    if (!q.key) continue
    params.set(q.key, q.example)
  }
  const qs = params.toString()

  const headers: HeaderRow[] = requestDocs.headers
    .filter((h) => h.key)
    .map((h) => ({ key: h.key, value: h.example }))

  return {
    defaultUrl: `${baseUrl}${resolvedPath}${qs ? `?${qs}` : ''}`,
    defaultHeaders: headers,
    defaultBody: requestDocs.body_example ?? '',
  }
}
